import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, TableSortLabel, Checkbox, Grid } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { checkApiStatus } from '../../../../utils';
import { globalGetService, globalDeleteService } from '../../../../utils/globalApiServices';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { PageLoader, STableLoader, Pagination } from '../../../../shared_elements';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { deleteQmeApi, getQualifiedAPi } from '../apiService';
import { qmiObj, QmeList, Qualified_CRU } from '../components';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import { useDispatch, useSelector } from 'react-redux';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { getStorage } from '../../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const QmeHd = ({ item, createSortHandler, sortInfo, toggleBulkOps, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Qualified Maintenance Events`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )
    }
    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "qualified_maintenance_event", operationType: ['D'] }}>
                        <Checkbox color='primary' size='small' onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '150px' }}> {tableSorting('reserve_account_id', 'Reserve Account')}</TableCell>
                <TableCell sx={{ minWidth: '160px' }}> {tableSorting('start_date', 'Validity Start Date')}</TableCell>
                <TableCell sx={{ minWidth: '160px' }}> {tableSorting('end_date', 'Validity End Date')}</TableCell>
                <TableCell sx={{ minWidth: '160px' }}> {tableSorting('qualified_items', 'Qualified Items')}</TableCell>
                <TableCell sx={{ minWidth: '160px' }}> {tableSorting('event', 'Event')}</TableCell>
            </TableRow>
        </TableHead>
    )
}
const QualifiedMaintenanceEvents = () => {
    const { leaseSlug } = useParams();
    const dispatch = useDispatch();
    const { fileUploadDetails } = useSelector((state) => state.leases);
    const params = { leaseSlug: leaseSlug }
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [qmeDetails, setQmeDetails] = useState({ list: [], pagination: {} });
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const [qmeCRU, setQmeCRU] = useState({ modal: false, data: null, mode: '' });
    const [deletQme, setDeleteQme] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
    const [isExport, seIsExport] = useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})


    useEffect(() => {
        const uploadedFileData = getApiResponse('qualified_maintenance_event',slug)
        getQmeList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed', { page_title: 'Qualified Maintenance Events' })
        setUploadFileProgressData({ uploadedFileData });
    }, [])
    const getQmeList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getQualifiedAPi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setQmeDetails(response.data.data);
            }
            loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);

        })
        dispatch(getStorage({ lease_slug: params?.leaseSlug, module_name: "qualified_maintenance_event" }))
    }
    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }
    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (qmeCRU?.modal) {
            setQmeCRU({
                ...qmeCRU,
                data: {
                    ...qmeCRU.data,
                    attachments: qmeCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getQmeList('', { per_page: qmeDetails?.pagination?.per_page });
    }
    const deleteQmeFn = () => {
        setLoading(true);
        const idsToDelete = deletQme?.modal && deletQme?.data?.id ? [deletQme?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteQmeApi(params), { ids: idsToDelete } )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Qualified Maintenance Event `, success_msg: response?.data?.message, item_ids: deletQme?.data || bulk?.ids, response: response?.data })
                    setDeleteQme({ modal: false, data: null });
                    getQmeList('', { per_page: qmeDetails?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], title: '', type: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Qualified Maintenance Event`, error_msg: response?.data?.message, item_ids: deletQme?.data || bulk?.ids, response: response?.data })
                }
            })
    }
    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getQmeList('pageLoader', { ...sortQuery, per_page: qmeDetails?.pagination?.per_page });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getQualifiedAPi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Qualified Maintenance Events`, page_type: page_type, })
    }

    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "qualified_maintenance_event",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments,response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
                getQmeList("", { per_page: qmeDetails?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
            }
        });
        setSlug({});
    };


    return (
        <>
        <LeasesBasicDetails/>
         <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
            <LeasesNav type="terms"/>
            <div className='lease-details-content contnet-overflow'>
                <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Qualified Maintenance Events" type="terms"/>
                            </Grid>
                            <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 8, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "qualified_maintenance_event", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" color='error' size="small">{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {qmeDetails?.list?.length > 0 ? <li className='lease-mobile-button'><Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "qualified_maintenance_event", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' variant="contained" color="primary" size='small' onClick={() => { setQmeCRU({ modal: true, data: qmiObj, mode: 'add' }); handleItemClicked('Add Item Button') }} > Add Qualified Maintenance Events </Button> </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: qmeDetails?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <QmeHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={qmeDetails?.list} toggleBulkOps={toggleBulkOps} />
                                <TableBody>
                                    {qmeDetails?.list?.length > 0 && qmeDetails?.list?.map((item, index) => {
                                        const uploadedFileData = getApiResponse('qualified_maintenance_event',item?.slug)
                                        return (
                                            <QmeList
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData}
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onEditFn={() => setQmeCRU({ modal: true, data: item, mode: 'edit' })}
                                                onView={() => setQmeCRU({ modal: true, data: item, mode: 'view' })}
                                                ondeleteQmeFn={() => {
                                                    setDeleteQme({ modal: true, data: item, });
                                                    setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                }}
                                                toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                            />
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        )}
                        {!skeletonLoader && !qmeDetails?.list?.length && <NoRecordFound />}
                    </div>
                    <Paper square>
                        <Pagination
                            pagination={qmeDetails?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getQmeList('pageLoader', { page: pageNum, per_page: qmeDetails.pagination.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getQmeList('pageLoader', { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
                        />
                    </Paper>
                </Paper>
            </div>
             </Paper>
            {qmeCRU.modal &&
                <Qualified_CRU
                    fileUpload={handleUpload}
                    qmeCRU={qmeCRU}
                    modeType={qmeCRU?.mode}
                    getResponseBack={() => {getQmeList('pageLoader', { per_page: qmeDetails?.pagination?.per_page }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onOpenAttachments={() => setAttachments({ modal: true, data: qmeCRU?.data, mode:'view' })}
                    onToggleModal={() => setQmeCRU({ modal: false, data: null, mode: '' })}
                />
            }
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Qualified Maintenance Events"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                    onViewDisabled={qmeCRU?.mode === 'view' || attachments?.mode==='view'}
                    permissionKey='qualified_maintenance_event'
                /> : null
            }
            {deletQme.modal || bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal ? bulk.modal : deletQme.modal}
                    title={`Delete ${bulk?.modal ? (bulk?.ids?.length === (qmeDetails?.list?.length || 0) ? "All Qualified Maintenance Events" : "Selected Qualified Maintenance Events") : "Qualified Maintenance Events"}`}
                    content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids?.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : ( setDeleteQme({ modal: false, data: null }), setBulk({ modal: false, ids: [], title: '', type: '' }) ) }
                    onDeleteRecords={() => deleteQmeFn()}
                /> : null}

            {
              revisionHistory.modal &&  
              <RevisionHistory 
              moduleName={"qualified_maintenance_event"}
              revisionHistory={revisionHistory}
              onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
             />
            }   
            <FileUploadLayout
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                onDownloadComplete={()=> setSlug({})}
            />

            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(QualifiedMaintenanceEvents, { application: 'lease_revamp', feature: 'qualified_maintenance_event', operationType: ['R'], leaseNav: true });
